<template>
  <span class="dol-price" :style="defaultStyle">
    <span class="dol-price-unit">{{ unit }}</span>
    <span class="dol-price-int" :style="intStyle">{{ int }}</span>
    <span class="dol-price-decimals">.{{ decimals }}</span>
  </span>
</template>

<script>
import dolphinCoreConfig from '../config';
export default {
  name: "dolPrice",
  props: {
    value: {type: Number},
    toFixed: {type: Number, default: dolphinCoreConfig.dolPrice.toFixed},
    defaultColor: {type: String, default: dolphinCoreConfig.dolPrice.defaultColor},
    defaultSize: {type: String, default: dolphinCoreConfig.dolPrice.defaultSize},
    intColor: {type: String, default: dolphinCoreConfig.dolPrice.intColor},
    intSize: {type: String, default: dolphinCoreConfig.dolPrice.intSize},
    unit: {type: String, default: dolphinCoreConfig.dolPrice.unit},
  },
  computed: {
    int(){
      let int = 0;
      if(this.value){
        int = Math.floor(this.value);
      }
      return int;
    },
    decimals(){
      let decimals = '00';
      if(this.value){
        decimals = this.value.toFixed(this.toFixed).split('.')[1];
      }
      return decimals;
    },
    defaultStyle(){
      return {color: this.defaultColor, fontSize: this.defaultSize};
    },
    intStyle(){
      return {color: this.intColor, fontSize: this.intSize};
    },
  }
}
</script>

<style lang="scss" scoped>
.dol-price {
  margin-right: 6px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-size: 14px;
  color: #FFFFFF;
  .dol-price-int{
    font-size: 20px;
  }
}
</style>
